// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".OrderReasonFields-module__radioGroup--nUhNjkX4{display:flex;flex-direction:column;gap:8px}", "",{"version":3,"sources":["webpack://./src/entities/billing/ui/orderReasonFields/OrderReasonFields.module.scss"],"names":[],"mappings":"AAAA,gDACE,YAAA,CACA,qBAAA,CACA,OAAA","sourcesContent":[".radioGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"radioGroup": "OrderReasonFields-module__radioGroup--nUhNjkX4"
};
export default ___CSS_LOADER_EXPORT___;
